import React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import TableOfContents from './TableOfContents'
import clsx from 'clsx'
import * as css from './RichtextModule.module.css'

export default function RichtextModule({
	title,
	_rawContent,
	tableOfContents,
}) {
	const rawHeadings = _rawContent.filter((block) =>
		['h2'].includes(block.style),
	)
	const headings = getBlockText(rawHeadings, '\n').split('\n')

	return (
		<section
			className={clsx(
				'ctnr padding space-y-12',
				tableOfContents && '<md:!pt-0',
			)}
		>
			{title && (
				<header className="mx-auto max-w-2xl text-balance text-center">
					<h2 className="h1">{title}</h2>
				</header>
			)}

			<div
				className={clsx(
					tableOfContents &&
						'grid items-start gap-x-12 gap-y-8 md:grid-cols-[auto_1fr]',
				)}
			>
				{tableOfContents && <TableOfContents headings={headings} />}

				<div className={clsx(css.body, 'richtext mx-auto max-w-[800px]')}>
					<SanityBlock body={_rawContent} />
				</div>
			</div>
		</section>
	)
}

function getBlockText(block, lineBreakChar = '↵ ') {
	return (
		block?.reduce((a, c, i) => {
			const text = c.children?.flatMap((c) => c.text).join('') || ''
			return a + text + (i !== block.length - 1 ? lineBreakChar : '')
		}, '') || ''
	)
}
